const { options } = require("preact");

const lensOptions = [
	{ label: '5°', value: 5, factor: 1345250 }, // factor = candela
	{ label: '10°', value: 10, factor: 783310 },
	{ label: '14°', value: 14, factor: 404780 },
	{ label: '19°', value: 19, factor: 243520 },
	{ label: '26°', value: 26, factor: 176255 },
	{ label: '36°', value: 36, factor: 90885 },
	{ label: '50°', value: 50, factor: 45650 },
	{ label: '70°', value: 70, factor: 22270 },
	{ label: '90°', value: 90, factor: 11330 }
];

const lampOptions = [
	{ label: '575W', value: 575, factor: 0.56 },
	{ label: '750W', value: 750, factor: 1 }
];

function factorForLensAndLamp(lens, lamp) {
	let factor = lensOptions.find(l => l.value === lens).factor;
	factor = factor * lampOptions.find(l => l.value === lamp).factor;
	return factor;
}

function illuminationForLensLampThrow(lens, lamp, dist) {
	const factor = factorForLensAndLamp(lens, lamp);
	return factor/ (dist * dist);
}

function lensOptionsForFixture(beam) {
	const options = lensOptions.map(opt => {
		const { label, value } = opt;
		const { lamp, beamThrow } = beam;
		const fc = Math.round(illuminationForLensLampThrow(value, lamp, beamThrow));
		return { ...opt, label: `${label} = ${fc} fc` };
	});
	return options;
}

function lampOptionsForFixture(beam) {
	const options = lampOptions.map(opt => {
		const { label, value } = opt;
		const { beamAngle, beamThrow } = beam;
		const fc = Math.round(illuminationForLensLampThrow(beamAngle, value, beamThrow));
		return { ...opt, label: `${label} = ${fc} fc` };
	});
	return options;
}

module.exports = {
	illuminationForLensLampThrow,
	lensOptionsForFixture,
	lampOptionsForFixture
};



// WEBPACK FOOTER //
// ./photometrics.js